// This file is required for the paths to be correct when using code splitting and deploying to INCA.

// @ts-ignore webpack
__webpack_public_path__ = process.env.RCC_PUBLIC_FILES_DIR ? `/Public/Files/${process.env.RCC_PUBLIC_FILES_DIR}/` : '/';
(global as any).publicPath = process.env.RCC_PUBLIC_FILES_DIR ? `/Public/Files/${process.env.RCC_PUBLIC_FILES_DIR}/` : '/';
